import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { easing } from './lib/easing';
import './lib/register-icons';

const Icon = styled(FontAwesomeIcon).attrs(() => ({
  focusable: false,
}))`
  color: inherit;
  font-size: inherit;
  line-height: inherit;
`;

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
};

export default Icon;

const Button = styled.button`
  align-items: center;
  background: none;
  border-radius: 6px;
  border: none;
  color: var(--icon);
  display: flex;
  font-size: 16px;
  height: 24px;
  justify-content: center;
  transition: ${easing('color')};
  width: 24px;

  :hover {
    color: var(--icon-hover);
  }

  :focus {
    outline: none;
    box-shadow: 0 0 0 2px var(--input-focus);
  }

  ${Icon} {
    width: 100%;
  }
`;

const BaseIconButton = ({
  icon,
  label,
  onClick,
  type = 'button',
  ...props
}) => {
  return (
    <Button aria-label={label} onClick={onClick} type={type} {...props}>
      <Icon icon={icon} />
    </Button>
  );
};

BaseIconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
};

export const IconButton = styled(BaseIconButton)``;

/**
 * @deprecated
 * This is a temporary Icon component that adds a right margin
 * to be used inside our old CButton.
 * Once we migrate all CButton to our new Button we can just
 * replace all instances of IconWithinCButton with our new Icon.
 * Our new Button automatically adds right margin to its child Icons.
 * Added a gray prop for OCD reasons about the icon color inside white buttons
 */
export const IconWithinCButton = styled(Icon)`
  margin-right: 10px;
  ${({ gray }) => gray && `color: var(--icon)`}
`;
